import React from 'react';
import PropTypes from 'prop-types';
import AATexLogo from '../atoms/_atoms.atex-logo';
import AToolTip from '../atoms/_atoms.tool-tip';

export default class MATexLogo extends React.Component {
	constructor(props) {
		super(props);
		this.state = { showTooltip: 'none' };
		this.bindHandle();
	}

	bindHandle() {
		this.handleHoverEventListener = this.handleHoverEventListener.bind(this);
		this.handleHideTooltip = this.handleHideTooltip.bind(this);
	}

	handleHoverEventListener() {
		this.setState({ showTooltip: 'flex' });
	}

	handleHideTooltip() {
		this.setState({ showTooltip: 'none' });
	}

	render() {
		return (
			<figure
				className={`m-atex-logo ${this.props.className}`}
				onMouseLeave={this.handleHideTooltip}
				onMouseEnter={this.handleHoverEventListener}
			>
				<AATexLogo src={this.props.src} alt={this.props.alt} className="atex-logo" />
				<figcaption style={{ display: this.state.showTooltip }}>
					<AToolTip
						text={this.props.tooltip}
						position="top-right"
					/>
				</figcaption>
			</figure>
		);
	}
}

MATexLogo.propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string.isRequired,
	tooltip: PropTypes.string,
	className: PropTypes.string,
};

MATexLogo.defaultProps = {
	tooltip: undefined,
	className: "",
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.atex-logo.js